import { takeLeading, call, put } from "redux-saga/effects";
import { request, showNotification, entitiesActions } from "@thewebops/admin-panel";
import actions from "./actions";
import { MESSAGE_EXPORT_TYPE } from "./constants";

// The API builds the spreadsheet in the background (api #93); the file appears in this list when ready.
function* exportMessages(action) {
  const { entity } = action.payload;
  const { success, failure } = actions.exportMessages;
  try {
    yield call(request, {
      url: "admin/export_documents",
      method: "post",
      authenticated: true,
      data: { exportable_type: MESSAGE_EXPORT_TYPE },
    });
  } catch (error) {
    yield put(failure());
    const forbidden = error?.response?.status === 403;
    showNotification(forbidden ? "You are not allowed to export messages." : "The message export could not be started.", "error");
    return;
  }
  // Outside the try: the export exists now, so nothing after this may report it as not started.
  yield put(success());
  showNotification("The message export is being prepared. It will appear in this list when ready.", "success");
  yield put(entitiesActions[entity.name].list.request({ entity }));
}

function* watchEntityExportMessages() {
  // A second click while the first export is starting is ignored, so it can't start two exports.
  yield takeLeading(actions.exportMessages.request, exportMessages);
}

export default [watchEntityExportMessages];
